// noinspection TsLint
export const NotificationSource = {
    TEST: { name: 'TEST', id: 1 },
    MANUAL: { name: 'MANUAL', id: 2 },
    WELCOME: { name: 'WELCOME', id: 3 },
    FEED: { name: 'FEED', id: 4 },
    PREVIEW: { name: 'PREVIEW', id: 5 },
};
